import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import {
  ButtonComponent,
  IconComponent,
  InputComponent,
  PasswordComponent,
} from '@app-ui';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService, BaseComponent, CustomToasterService } from '@app-utils';
import { finalize, takeUntil } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'auth-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.less',
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonComponent,
    InputComponent,
    PasswordComponent,
    ReactiveFormsModule,
    RouterLink,
    IconComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordComponent extends BaseComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _apiSvc = inject(ApiService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _customToaster = inject(CustomToasterService);
  private readonly _translate = inject(TranslateService);
  private readonly _resendMessage = this._translate.instant(
    'auth.page-component.forgot-password.lbl.resend-in-sec',
    { value: '##sec##' },
  );

  countdown = 0;
  buttonText = this._translate.instant('common-keywords.send');

  fg: FormGroup = this._fb.group({
    email: [null, [Validators.required, Validators.email]],
  });

  forgotPassword() {
    this.loading$.next(true);
    const { email } = this.fg.value;
    this._apiSvc
      .forgotPassword(email.trim())
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading$.next(false)),
      )
      .subscribe(() => {
        this._customToaster.success(
          this._translate.instant(
            'auth.page-component.forgot-password.message.sent-success',
          ),
        );
        this.countdown = 59;
        this.buttonText = this._resendMessage.replaceAll(
          '##sec##',
          this.countdown < 10 ? '0' + this.countdown : this.countdown,
        );
        const interval = setInterval(() => {
          this.countdown -= 1;
          this.buttonText = this._resendMessage.replaceAll(
            '##sec##',
            this.countdown < 10 ? '0' + this.countdown : this.countdown,
          );

          if (this.countdown === 0) {
            clearInterval(interval);
            this.buttonText = this._translate.instant('common-keywords.resend');
          }
          this._cdr.detectChanges();
        }, 1000);
      });
  }
}
